<template>
  <div class="d-flex justify-content-start align-items-center" style="gap: 10px">
    <div v-if="!isLoading">
      <button v-on:click="action" class="mf_btn_blue">{{ title }}</button>
    </div>
    <div v-else class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <div v-if="time > 0">{{ time }}</div>
  </div>
</template>
<script>
export default {
  props: {
    title: { require: true },
    action: { require: true },
    isLoading: { require: true },
    time: { require: true },
  },
};
</script>
